import {ContextKey} from '@ozark/functions/src/functions/express/private/types/Context';
import {PaginatedRejectsResponse} from '@ozark/functions/src/functions/express/private/types/Rejects';
import {CancelToken} from 'axios';
import {ActiveFilter} from '../components';
import {toQuery} from '../util';
import {ApiBase} from './ApiBase';
import {SearchCriteria} from './SearchCriteria';

export class RejectsApi extends ApiBase {
  getRejects = (
    searchCriteria: SearchCriteria,
    mid?: string,
    filters?: ActiveFilter[],
    cancelToken?: CancelToken
  ) => {
    const queryString = toQuery(searchCriteria, filters);
    return this.get<PaginatedRejectsResponse>(
      `rejects?${queryString}`,
      {
        [ContextKey.Mid]: mid,
      },
      cancelToken
    );
  };
  updateReject = (
    id: string,
    data: {field: string; value: string | number}[],
    cancelToken?: CancelToken
  ) => {
    return this.post(`rejects/${id}`, data, undefined, cancelToken);
  };
  insertReject = (data: {field: string; value: string | number}[], cancelToken?: CancelToken) => {
    return this.post('rejects', data, undefined, cancelToken);
  };
}
